module.exports = __webpack_public_path__ + "img/e5165c6.jpg";